import { THEME_TYPE } from 'interfaces';
import { makeAutoObservable } from 'mobx';
import { DefaultTheme } from 'styled-components';

import { darkTheme, lightTheme } from 'styles/theme';

class UIStore {
	theme: DefaultTheme = lightTheme;
	// gender = '';

	constructor() {
		makeAutoObservable(this);
	}

	get isLightTheme(): boolean {
		return this.theme.type === THEME_TYPE.LIGHT;
	}

	changeTheme = (): void => {
		this.theme = this.isLightTheme ? darkTheme : lightTheme;
	};

	setTheme = (themeType: THEME_TYPE): void => {
		this.theme = themeType === THEME_TYPE.DARK ? darkTheme : lightTheme;
	};

	// setGender = (value: string): void => {
	// 	this.gender = value;
	// 	console.log(this.gender);
	// };
}

export const uiStore = new UIStore();
